function right_rotate(value: number, amount: number) {
  return (value >>> amount) | (value << (32 - amount))
}

export class Crypto {
  static h: number[]
  static k: number[]
  static hash_sha256(ascii: string) {
    const mp = Math.pow
    const max_word = mp(2, 32)
    let i, j // Used as a counter across the whole file
    let result = ''

    const words: number[] = []
    const ascii_bit_len = ascii.length * 8

    //* caching results is optional - remove/add slash from front of this line to toggle
    // Initial hash value: first 32 bits of the fractional parts of the square roots of the first 8 primes
    // (we actually calculate the first 64, but extra values are just ignored)
    let hash = (this.h = this.h || [])
    // Round constants: first 32 bits of the fractional parts of the cube roots of the first 64 primes
    const k = (this.k = this.k || [])
    let prime_counter = k.length
    /*/
    var hash = [], k = [];
    var primeCounter = 0;
    //*/

    const is_composite: Record<number, number> = {}
    for (let candidate = 2; prime_counter < 64; candidate++) {
      if (!is_composite[candidate]) {
        for (i = 0; i < 313; i += candidate) {
          is_composite[i] = candidate
        }
        hash[prime_counter] = (mp(candidate, 0.5) * max_word) | 0
        k[prime_counter++] = (mp(candidate, 1 / 3) * max_word) | 0
      }
    }

    ascii += '\x80' // Append Ƈ' bit (plus zero padding)
    while ((ascii.length % 64) - 56) ascii += '\x00' // More zero padding
    for (i = 0; i < ascii.length; i++) {
      j = ascii.charCodeAt(i)
      if (j >> 8) return // ASCII check: only accept characters in range 0-255
      words[i >> 2] |= j << (((3 - i) % 4) * 8)
    }
    words[words.length] = (ascii_bit_len / max_word) | 0
    words[words.length] = ascii_bit_len

    // process each chunk
    for (j = 0; j < words.length; ) {
      const w = words.slice(j, (j += 16)) // The message is expanded into 64 words as part of the iteration
      const oldHash = hash
      // This is now the undefinedworking hash", often labelled as variables a...g
      // (we have to truncate as well, otherwise extra entries at the end accumulate
      hash = hash.slice(0, 8)

      for (i = 0; i < 64; i++) {
        const i2 = i + j
        // Expand the message into 64 words
        // Used below if
        const w15 = w[i - 15],
          w2 = w[i - 2]

        // Iterate
        const a = hash[0],
          e = hash[4]
        const temp1 =
          hash[7] +
          (right_rotate(e, 6) ^ right_rotate(e, 11) ^ right_rotate(e, 25)) + // S1
          ((e & hash[5]) ^ (~e & hash[6])) + // ch
          k[i] +
          // Expand the message schedule if needed
          (w[i] =
            i < 16
              ? w[i]
              : (w[i - 16] +
                  (right_rotate(w15, 7) ^ right_rotate(w15, 18) ^ (w15 >>> 3)) + // s0
                  w[i - 7] +
                  (right_rotate(w2, 17) ^ right_rotate(w2, 19) ^ (w2 >>> 10))) | // s1
                0)
        // This is only used once, so *could* be moved below, but it only saves 4 bytes and makes things unreadble
        const temp2 =
          (right_rotate(a, 2) ^ right_rotate(a, 13) ^ right_rotate(a, 22)) + // S0
          ((a & hash[1]) ^ (a & hash[2]) ^ (hash[1] & hash[2])) // maj

        hash = [(temp1 + temp2) | 0].concat(hash) // We don't bother trimming off the extra ones, they're harmless as long as we're truncating when we do the slice()
        hash[4] = (hash[4] + temp1) | 0
      }

      for (i = 0; i < 8; i++) {
        hash[i] = (hash[i] + oldHash[i]) | 0
      }
    }

    for (i = 0; i < 8; i++) {
      for (j = 3; j + 1; j--) {
        const b = (hash[i] >> (j * 8)) & 255
        result += (b < 16 ? 0 : '') + b.toString(16)
      }
    }
    return result
  }
}
